/* @flow */
export const imagePickerMenuIds = {
    annotate: 'annotate',
    delete: 'delete',
    import: 'import',
    display: 'display',
    takePhoto: 'takePhoto',
    signature: 'signature',
};
